/**
 * LifeScribe Brand Colors
 * Official brand palette for consistent theming
 *
 * Brand Identity:
 * - Deep Teal: Primary brand color, conveys trust and professionalism
 * - Warm Gold: Accent color, represents premium quality and legacy
 * - Soft Cream: Background color, warm and approachable
 */

export const brandColors = {
  // Primary Palette
  deepTeal: '#1A5F7A',      // Primary brand color - headers, primary elements
  warmGold: '#D4AC0D',      // Accent color - CTAs, highlights, premium elements
  softCream: '#F9F3E9',     // Backgrounds, text areas, cards

  // Secondary Palette
  richBurgundy: '#7D1935',  // Special features, emphasis
  forestGreen: '#146152',   // Growth, legacy-related elements
  slateGray: '#5D6D7E',     // UI elements, body text, secondary text

  // Derived Colors (for gradients, shadows, hover states)
  deepTealDark: '#144B5F',   // Darker teal for gradients and hover states
  deepTealLight: '#2A7F9A',  // Lighter teal for subtle backgrounds
  warmGoldLight: '#E5BD1F',  // Lighter gold for shimmer effects
  warmGoldDark: '#B89B0B',   // Darker gold for pressed states

  // Neutral colors
  white: '#FFFFFF',
  black: '#000000',

  // Activation Funnel 4-band discrete scale (added for Prompt 02)
  // Red = high retention (75–100% passed), Blue = cold/leaking (0–25%)
  bandRetained: '#B0202F',  // Red    — 75–100% step-over-step retention
  bandMedium:   '#E07A1F',  // Orange — 50–75%
  bandLow:      '#E8C20E',  // Yellow — 25–50%
  bandCold:     '#1A5F7A',  // Blue (deepTeal) — 0–25% cold/leaking
} as const;

export type BrandColor = keyof typeof brandColors;

// Brand tagline
export const brandTagline = "Your life, amplified and eternal.";

// Brand fonts
export const brandFonts = {
  heading: "'Playfair Display', serif",
  body: "'Source Sans Pro', sans-serif",
  accent: "'Montserrat', sans-serif",
};
